
import { Modal, Box } from '@material-ui/core';
import { ModalBody, ModalFooter, Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import HistoryTable from './HistoryTable';
import { HistoryAudioType } from '../../../types/AppTypes';
import { HistoryDocumentType } from '../../../types/AppTypes';

type Props = {
    openHistoryModal: boolean;
    closeHistoryModal: () => void;
    historyAudio: HistoryAudioType[] | undefined;
    historyDocument: HistoryDocumentType[] | undefined;
};

const HistoryModal = (props: Props): JSX.Element => {
  
  return (
    <div>
      
      <Modal
        open={props?.openHistoryModal}
        onClose={props?.closeHistoryModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="modal-wrapper" style={{width:'50%', maxHeight:'550px', overflow:'scroll'}}>
            <ModalBody>
                <HistoryTable dataAudio={props.historyAudio} dataDocument={props.historyDocument}/>
            </ModalBody>
            <ModalFooter>
            <Button variant="danger" onClick={props?.closeHistoryModal}>
                Close
              </Button>
          </ModalFooter>
        </Box>
      </Modal>
    </div>
  );
};

export default HistoryModal;
